import React, { useState } from "react";
// import logo from "../../assets/NavBar/Apec_Logo.svg";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Menu, X, ChevronLeft } from "lucide-react";
import { useTracking } from "../../hooks/useTracking"; // 1. Importamos el hook
import "./Navbar.css";

const Navbar = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { trackEvent } = useTracking(); // 2. Inicializamos el tracking

  // 3. Mantenemos la persistencia del hospital
  const hospitalClient = searchParams.get("hospital") || "Vertex_Lab_Direct";

  const handleBack = () => {
    navigate(-1);
  };

  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // 4. Función centralizada para manejar el menú y el tracking a la vez
  const handleNavClick = (destino) => {
    setIsOpen(false); // Cierra el menú en móviles
    trackEvent("click_nav_menu", {
      nav_target: destino, // "home", "sintomas", "tests", "clinicas"
      hospital_client: hospitalClient,
      source: "navbar"
    });
  };

  return (
    <div className="navbar">
      {/* ... */}
      <button className="back-button-mobile" onClick={handleBack}>
        <ChevronLeft size={28} />
      </button>

      <button className="menu-hamburguesa" onClick={toggleMenu}>
        {isOpen ? <X size={24} className="icon-x" /> : <Menu size={24} />}
      </button>

      {/* Menú con los onClick actualizados */}
      <ul className={`navbar-menu ${isOpen ? "open" : ""}`}>
        <Link
          to={"/"}
          onClick={() => handleNavClick("home")}
          className="menu-opcion"
        >
          <li>Home</li>
        </Link>
        <Link
          to={"/sintomas"}
          onClick={() => handleNavClick("sintomas")}
          className="menu-opcion"
        >
          <li>Síntomas</li>
        </Link>
        <Link
          to={"/tests"}
          onClick={() => handleNavClick("tests")}
          className="menu-opcion"
        >
          <li>Test</li>
        </Link>
        <Link
          to={"/clinicas"}
          onClick={() => handleNavClick("clinicas")}
          className="menu-opcion"
        >
          <li>Clínicas</li>
        </Link>
      </ul>
    </div>
  );
};

export default Navbar;
